import { render, staticRenderFns } from "./tableComBanner.vue?vue&type=template&id=3a6cef37&scoped=true"
import script from "./tableComBanner.vue?vue&type=script&lang=js"
export * from "./tableComBanner.vue?vue&type=script&lang=js"
import style0 from "./tableComBanner.vue?vue&type=style&index=0&id=3a6cef37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6cef37",
  null
  
)

export default component.exports